import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconCaretDown$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconCaretDown extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '8965a321fa7d9475426e005f9f9be444f583c150', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '4f4157601de64a9090e417a12d9489a18dc0722a', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '46eb24cbed012f6c65bd33beb3f64a9f46e5b6f5', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "m11.21 13.79 5.28-5.28a.3.3 0 0 0-.21-.51H5.72a.3.3 0 0 0-.21.51l5.28 5.28a.29.29 0 0 0 .42 0", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-caret-down", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-caret-down"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-caret-down":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconCaretDown$1);
            }
            break;
    } });
}

const CosmosIconCaretDown = CosmosIconCaretDown$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconCaretDown, defineCustomElement };
